module.exports = __webpack_public_path__ + "static/media/afl-everyday-digital.efe0cf47.png";